<template>
	<b-modal v-model="isShowPopup" dialog-class="modal-detail" @hidden="resetModal" scrollable :no-close-on-backdrop=true @ok="addButtonAction" title="Add Data PartGoodReceiptCase">
		<b-card>
			<b-row>
				<b-col cols="12" lg="6">
				<app-input-combobox-autocomplete :options="purchaseOrderDetails" optionsLabel="qtyPo" optionsKey="id" label-cols-lg="12" label="Purchase Order Detail" id="input-" size="sm" :model.sync="model.purchaseOrderDetailId"   :selected="model.purchaseOrderDetail != null ? model.purchaseOrderDetail.qtyPo : ''" @input="getPurchaseOrderDetails" />
				<app-input-combobox-autocomplete :options="parts" optionsLabel="partNumber" optionsKey="id" label-cols-lg="12" label="Part" id="input-" size="sm" :model.sync="model.partId" :isRequired="true" :state="validateState('partId')" :errorMessage="getErrorMessage(errorMessage.partId, 'partId')"   :selected="model.part != null ? model.part.partNumber : ''" @input="getParts" />
				<app-input-textbox id="fieldset-supplier-case-number" label-cols-lg="12" label="Supplier Case Number" label-for="input-supplier-case-number" size="sm" :model.sync="model.supplierCaseNumber" :isRequired="true" :state="validateState('supplierCaseNumber')" :errorMessage="getErrorMessage(errorMessage.supplierCaseNumber, 'supplierCaseNumber')"  />
				<app-input-combobox-autocomplete :options="controlCards" optionsLabel="controlCardNumber" optionsKey="id" label-cols-lg="12" label="Control Card" id="input-" size="sm" :model.sync="model.controlCardId"   :selected="model.controlCard != null ? model.controlCard.controlCardNumber : ''" @input="getControlCards" />
				<app-input-textbox id="fieldset-qty-receive" label-cols-lg="12" label="Qty Receive" label-for="input-qty-receive" size="sm" :model.sync="model.qtyReceive" :isRequired="true" :state="validateState('qtyReceive')" :errorMessage="getErrorMessage(errorMessage.qtyReceive, 'qtyReceive')"  />
					</b-col>
					<b-col cols="12" lg="6">
				<app-input-textbox id="fieldset-qty-adjustment" label-cols-lg="12" label="Qty Adjustment" label-for="input-qty-adjustment" size="sm" :model.sync="model.qtyAdjustment"  />
				<app-input-textbox id="fieldset-qty-actual" label-cols-lg="12" label="Qty Actual" label-for="input-qty-actual" size="sm" :model.sync="model.qtyActual"  />
				<app-input-textarea id="fieldset-remark" label-cols-lg="12" label="Remark" label-for="input-remark" size="sm" :model.sync="model.remark"  />
				<app-input-combobox-autocomplete :options="partGoodReceiptDetails" optionsLabel="part" optionsKey="id" label-cols-lg="12" label="Part Good Receipt Detail" id="input-" size="sm" :model.sync="model.partGoodReceiptDetailId"   :selected="model.partGoodReceiptDetail != null ? model.partGoodReceiptDetail.part : ''" @input="getPartGoodReceiptDetails" />

				</b-col>
			</b-row>
		</b-card>
		<b-overlay :show="isBusy" no-wrap></b-overlay>
		<template #modal-footer="{ ok, cancel }">
      		<slot name="modal-left-button"></slot>
			<b-button size="sm" class="btn-outline-danger float-right" @click="cancel()">
				Close
			</b-button>
      		<b-overlay
					:show="isBusy"
					rounded
					opacity="0.6"
					spinner-small
					spinner-variant="primary"
					class="float-right "
					>
      			<b-button size="sm" class="float-right btn-fill-success" @click="ok()">
				Save
			</b-button>
      		</b-overlay>
		</template>
	</b-modal>
</template>
<style lang="scss" scoped>
	::v-deep .modal-dialog {
		width: 70% !important; 
	}

	@media (max-width: 576px) {
		::v-deep .modal-dialog {
			width: calc(100%) !important;
		}
	}
</style>
<script>
import axios from 'axios';
import { validationMixin } from "vuelidate";
import { required, minLength } from "vuelidate/lib/validators";
import PartGoodReceiptCase from '@/models/PartGoodReceipt/PartGoodReceiptCase';
import PartGoodReceiptCaseFilter from '@/filters/PartGoodReceipt/PartGoodReceiptCaseFilter';

import PartGoodReceipt from '@/models/PartGoodReceipt/PartGoodReceipt';
import PartGoodReceiptFilter from '@/filters/PartGoodReceipt/PartGoodReceiptFilter';
import AppInputComboboxAutocomplete from '@/components/AppInputComboboxAutocomplete';
import PurchaseOrderDetail from '@/models/PurchaseOrder/PurchaseOrderDetail';
import PurchaseOrderDetailFilter from '@/filters/PurchaseOrder/PurchaseOrderDetailFilter';
import Part from '@/models/Part/Part';
import PartFilter from '@/filters/Part/PartFilter';
import AppInputTextbox from '@/components/AppInputTextbox';
import ControlCard from '@/models/ControlCard/ControlCard';
import ControlCardFilter from '@/filters/ControlCard/ControlCardFilter';
import AppInputTextarea from '@/components/AppInputTextarea';
import PartGoodReceiptDetail from '@/models/PartGoodReceipt/PartGoodReceiptDetail';
import PartGoodReceiptDetailFilter from '@/filters/PartGoodReceipt/PartGoodReceiptDetailFilter';
import PopupRouterView from '@/components/PopupRouterView';
export default {
	props: ['modelId', 'openPopup','addButtonMethod', 'resetMethod'],
	components : {
		AppInputComboboxAutocomplete,
		AppInputTextbox,
		AppInputTextarea,
		PopupRouterView,
	},
	mixins : [validationMixin],
	validations: {
		model: {
		partId: {required},
			supplierCaseNumber: {required},
			qtyReceive: {required},
		}
	},
	data() {
		return {
			model : {},
			errorMessage : {
				partId: { required : "Part is Required."},
				supplierCaseNumber: { required : "Supplier Case Number is Required."},
				qtyReceive: { required : "Qty Receive is Required."},
			},
			purchaseOrderDetails : [],
			parts : [],
			controlCards : [],
			partGoodReceiptDetails : [],
			isBusy: false,
		}
	},
	methods : {
		getPartGoodReceiptCase : async function(id) {
			this.isBusy = true;
			PartGoodReceiptCase.getData(this, id).then(result => {
				this.model = result;
				this.isBusy = false;
			}).catch(error => { this.isBusy = false; });
		},
		getPurchaseOrderDetails : async function(input) {
			let filter = new PurchaseOrderDetailFilter();
			if (input != undefined) {
				filter.qtyPo = input;
			}
			PurchaseOrderDetail.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.purchaseOrderDetails = result.data
				}
			})
			.catch(error => {});
		},
		getParts : async function(input) {
			let filter = new PartFilter();
			if (input != undefined) {
				filter.partNumber = input;
			}
			Part.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.parts = result.data
				}
			})
			.catch(error => {});
		},
		getControlCards : async function(input) {
			let filter = new ControlCardFilter();
			if (input != undefined) {
				filter.controlCardNumber = input;
			}
			ControlCard.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.controlCards = result.data
				}
			})
			.catch(error => {});
		},
		getPartGoodReceiptDetails : async function(input) {
			let filter = new PartGoodReceiptDetailFilter();
			if (input != undefined) {
				filter.part = input;
			}
			PartGoodReceiptDetail.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.partGoodReceiptDetails = result.data
				}
			})
			.catch(error => {});
		},

		validateState(name) {
			const { $dirty, $error } = this.$v.model[name];
			return $dirty ? !$error : null;
		},
		getErrorMessage(message, name) {
			if (this.$v.model[name].required != undefined && !this.$v.model[name].required) {
				if (message.required) return message.required;
			}
		},
		addButtonAction(modalEvent) {
			modalEvent.preventDefault();

			this.$v.model.$touch(); 
			if (this.$v.model.$anyError) {
				return;
			} else {
				let model = this.model;
				let promises = Array();
				let _this = this;
					

					
				Promise.all(promises).then((results) => {
					_this.$emit("addButtonMethod", modalEvent, _this.model); 
				});

				this.$nextTick(() => { this.$v.$reset() })
			}
		},
		resetModal() {
			this.$emit('resetMethod');
			this.$v.$reset();
		},

	},	beforeMount() {
		//this.getPurchaseOrderDetails();
		//this.getParts();
		//this.getControlCards();
		//this.getPartGoodReceiptDetails();
	},
	async mounted(){
	},
	watch : {
		modelId(newValue) {
			if (newValue != null && newValue != undefined && newValue != '') {
				this.getPartGoodReceiptCase(newValue);
			} else {
				this.model = {};
			}
		},
		openPopup(newValue) {
			if (newValue) {
				this.getPurchaseOrderDetails();
				this.getParts();
				this.getControlCards();
				this.getPartGoodReceiptDetails();
				if (this.modelId != null && this.modelId != undefined && this.modelId != '') {
					this.getPartGoodReceiptCase(this.modelId);
				}
			} else {
				this.model = {};
			}
		}
	},
	computed: {
		isShowPopup : {
			get: function () {
				if (this.openPopup) return true;
				else return false;
			},
			set: function (newValue) {}
		},
	}
}
</script>
